import { z } from 'zod';

const DocumentSourceValues = ['app', 'bo', 'wm_app'] as const;
const UserDocumentSourceValues = [...DocumentSourceValues, 'alpaca', 'fourthline'] as const;

export const ZodDocumentSource = z.enum(DocumentSourceValues);

export const ZodUserDocumentSource = z.enum(UserDocumentSourceValues);
